<div class="painel-header">
  <div class="header-content">
    <div class="header-text">
      <h2>Quadro de Notas do Examinador</h2>
      <p class="mat-body-1">{{this.emailUsuario}}</p>
    </div>
    <button mat-flat-button color="primary" class="btn-instrucoes" (click)="toggleInstrucoes()">
      <mat-icon>{{ instrucoesExpandidas ? 'close' : 'help_outline' }}</mat-icon>
      {{ instrucoesExpandidas ? 'Fechar' : 'Instruções' }}
    </button>
  </div>
</div>

<mat-card *ngIf="instrucoesExpandidas" class="card-instrucoes" [@slideDown]>
  <mat-card-content class="instrucoes-content">
    <div class="secao-instrucoes">
      <h3><mat-icon>description</mat-icon>Importante</h3>
      <ul>
        <li>No caso de <strong>empate</strong>, informe o <strong>conceito</strong> para desempate dos candidatos na respectiva coluna.</li>
        <li><strong>É obrigatório informar uma justificativa</strong> sempre que você inserir ou alterar um conceito para desempate.</li>
        <li>Para <strong>visualizar a justificativa</strong> de um conceito atribuído, <strong>posicione o mouse sobre o campo de conceito</strong> que ela será exibida.</li>
        <li><strong>Não é permitido utilizar o mesmo conceito</strong> para dois ou mais candidatos que possuem a <strong>mesma nota</strong>. Cada candidato empatado deve receber um conceito diferente.</li>
      </ul>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="existemEmpatesNaoResolvidos()" class="alerta-empate-pendente">
  <mat-card-header>
    <mat-icon>warning</mat-icon>
    <mat-card-title>Atenção</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Existem empates pendentes de resolução. Preencha os conceitos para todos os candidatos empatados utilizando letras em ordem alfabética.
  </mat-card-content>
</mat-card>

<mat-card *ngIf="!existemEmpatesNaoResolvidos()" class="alerta-empate-resolvido">
  <mat-card-header>
    <mat-icon>check_circle</mat-icon>
    <mat-card-title>Concluído</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    A classificação está pronta para esta fase.
  </mat-card-content>
</mat-card>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

  <ng-container matColumnDef="classificacao">
    <th class="col-order" mat-header-cell *matHeaderCellDef>#</th>
    <td class="col-order" mat-cell *matCellDef="let row">
      {{ row.classificacao }}      
    </td>
  </ng-container>

  <ng-container matColumnDef="inscricaoId">
    <th class="col-registration" mat-header-cell *matHeaderCellDef>Inscrição</th>
    <td class="col-registration" mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
  </ng-container>
  
  <ng-container matColumnDef="nome">
    <th class="col-name" mat-header-cell *matHeaderCellDef mat-sort-header>Nome Social / Nome</th>
    <td class="col-name" mat-cell *matCellDef="let row">
      <strong>{{ row.nomeSocial || row.nome }}</strong>
      <mat-icon *ngIf="dataSource.data[0]?.provaFase === 'FASE2' && row.jurado && !row.documentoJuradoInvalido" class="jury-icon clickable" matTooltip="Jurado - Clique para ver documento" (click)="visualizarDocumentoJurado(row.inscricaoId)">gavel</mat-icon>
      <img *ngIf="row.concorrerVagaDeficiente && exibirIconePCD()" src="assets/icons/Accessibility_logo.png" class="accessibility-icon" matTooltip="Pessoa com Deficiência" alt="Pessoa com Deficiência">
      <br />
      <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="nascimento">
    <th class="col-birthdate" mat-header-cell *matHeaderCellDef>Nascimento</th>
    <td class="col-birthdate" mat-cell *matCellDef="let row">
      {{ row.nascimento }}
    </td>    
  </ng-container>
  
  <ng-container *ngFor="let prova of dataSource.data[0]?.provas" 
    [matColumnDef]="prova.nomeProva">
    <th class="col-score" mat-header-cell *matHeaderCellDef>{{ prova.nomeProva }}</th>
    <td class="col-score" mat-cell *matCellDef="let row">
    {{ getNota(row, prova.nomeProva) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="mediaFinal">
    <th class="col-average" mat-header-cell *matHeaderCellDef>Média Final</th>
    <td class="col-average" mat-cell *matCellDef="let row">{{ row.mediaFinal }}</td>
  </ng-container>

  <ng-container matColumnDef="conceito" *ngIf="dataSource.data[0]?.provaFase === 'FASE2'">
    <th class="col-grade" mat-header-cell *matHeaderCellDef>Conceito</th>
    <td class="col-grade" mat-cell *matCellDef="let row">
      <div *ngIf="row.estaEmpatado && !row.existeClassificacao" class="flex-row-gap-8">
        <input
          class="grade-input"
          matInput
          maxlength="1"
          class="w-50"
          [(ngModel)]="row.conceito"
          [ngClass]="{'invalid-grade': !row.conceito}"
          (focus)="row.conceitoAnterior = row.conceito"
          (keypress)="permitirSomenteLetra($event)"
          (blur)="enviarConceito(row)"
          (keydown.enter)="enviarConceito(row)"
        />
        <button 
          *ngIf="row.justificativa"
          mat-icon-button 
          color="primary"
          (click)="mostrarJustificativa(row.justificativa)"
          matTooltip="Justificativa"
          class="icon-md">
          <mat-icon>description</mat-icon>
        </button>
      </div>
      <div *ngIf="row.conceito && row.existeClassificacao" class="grade-container">
        <span>{{ row.conceito }}</span>
        <button 
          *ngIf="row.justificativa"
          mat-icon-button 
          color="primary"
          (click)="mostrarJustificativa(row.justificativa)"
          matTooltip="Justificativa"
          class="icon-sm">
          <mat-icon>description</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
  <tr mat-row *matRowDef="let row; columns: colunasGrid;"></tr>

</table>

<div fxLayout="row" fxLayoutAlign="end center" class="mt-20">
  <button mat-raised-button color="primary" (click)="voltar()" matTooltip="Voltar para a listagem de provas">
    <mat-icon>arrow_back</mat-icon>
    Voltar
  </button>
</div>
